import {put, takeEvery} from 'redux-saga/effects';
import LightboxActions from "../actions";
import TransactionActions from "../../Transaction/actions";
import dayjs from 'dayjs';

const {
    getPdfPreview,
} = TransactionActions;

export default function* onCurrentIndexChange(action) {
    const { transactionType, request } = action;

    const file = {
        file_id: 'pdf-preview',
        created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        file: {
            file_id: 'pdf-preview',
            url: null,
            mime_type: "application/pdf",
            filename: "Pdf Preview.pdf",
        },
        id: null,
        is_shared: null,
        hasError: null,
    };

    // Reading file (from File Manager)
    yield put(LightboxActions.setFiles([file]));
    yield put(getPdfPreview(transactionType, request));

    // Wait for Success/Error
    yield takeEvery(
        [TransactionActions.TRANSACTION_GET_PDF_PREVIEW_SUCCESS,
            TransactionActions.TRANSACTION_GET_PDF_PREVIEW_ERROR],
        function* (action) {
            let updatedFile = {...file};
            // Success
            if (action.type === TransactionActions.TRANSACTION_GET_PDF_PREVIEW_SUCCESS) {
                updatedFile = {
                    ...file,
                    file: {
                        ...file.file,
                        url: action.blobUrl,
                    },
                };
            }
            // Error
            else if (action.type === TransactionActions.TRANSACTION_GET_PDF_PREVIEW_ERROR) {
                updatedFile = {
                    ...file,
                    hasError: true,
                };
            }

            yield put(LightboxActions.setFiles([updatedFile]));
        });

    return null;
}
